<!--<div class="text-3xl">Recommended Spaces</div>-->
<div class="item_list">
  <app-space-card *ngFor="let space of list" [space]="space"></app-space-card>
</div>
